import React from "react";
import { Link } from "react-router-dom";
import logo from "../logo.png";

function Header() {
  return (
    <header className="header">
      <div className="header-container">

        <div className="logo-box">
          <Link to="/">
            <img src={logo} alt="Logo" style={{ width: "100%" }} />
          </Link>
        </div>

        <nav className="nav-right">
          <ul className="nav-menu">

            <li className="dropdown">
              Documents
              <ul className="submenu">
                <li><Link to="/passports">Passports</Link></li>
                <li><Link to="/id-cards">ID Cards</Link></li>
        <li><Link to="/driver-licenses">Driver License</Link></li>
        <li><Link to="/bank-statements">Bank Statements</Link></li>
        <li><Link to="/utility-bills">Utility Bills</Link></li>
        <li><Link to="/business-formation">Business Documents</Link></li>
        <li><Link to="/other-docs">Other Documents</Link></li>
              </ul>
            </li>

            <li className="dropdown">
              Proxies
              <ul className="submenu">
                <li><Link to="/residential-proxies">Residential Proxies</Link></li>
                <li><Link to="/sim-card-proxy">SIM Card Proxy</Link></li>
                {/* <li><Link to="/single-proxies">Single Proxies</Link></li>
                <li><Link to="/proxy-accounts">Proxy Accounts</Link></li> */}
              </ul>
            </li>

            <li className="dropdown">
              Lookup Service
              <ul className="submenu">
                <li><Link to="/ssn-dob">SSN + DOB</Link></li>
                <li><Link to="/dl-id-numbers">DL / ID Numbers</Link></li>
                <li><Link to="/credit-score">Credit Score</Link></li>
                <li><Link to="/credit-report">Credit Report</Link></li>
                <li><Link to="/background-report">Background Report</Link></li>
                <li><Link to="/mothers-maiden-name">Mothers Maiden Name</Link></li>
              </ul>
            </li>

            <li className="dropdown">
              Accounts
              <ul className="submenu">
                <li><Link to="/streaming-accounts">Streaming Accounts</Link></li>
                <li><Link to="/social-accounts">Social Accounts</Link></li>
                <li><Link to="/financial-accounts">Financial Accounts</Link></li>
                <li><Link to="/self-reg-acc">Other Accounts</Link></li>
              </ul>
            </li>

          </ul>
        </nav>

      </div>
    </header>
  );
}

export default Header;
